import GetWebOrganisationLogoRequestModelBase from '../_generated/modelBases/get-web-organisation-logo-request-model-base';

export default class GetWebOrganisationLogoRequestModel extends GetWebOrganisationLogoRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
